import { render, staticRenderFns } from "./ApplicantEducations.vue?vue&type=template&id=8f59bbb8"
import script from "./ApplicantEducations.vue?vue&type=script&lang=js"
export * from "./ApplicantEducations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports